"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalContext_1 = require("../globalContext");
function applyMiddleware() {
    var middleware = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middleware[_i] = arguments[_i];
    }
    var next = finalDispatch;
    for (var i = middleware.length - 1; i >= 0; i--) {
        next = applyMiddlewareInternal(middleware[i], next);
    }
    globalContext_1.getGlobalContext().legacyDispatchWithMiddleware = next;
}
exports.default = applyMiddleware;
function applyMiddlewareInternal(middleware, next) {
    return function (action, actionType, args, actionContext) {
        return middleware(next, action, actionType, args, actionContext);
    };
}
function dispatchWithMiddleware(action, actionType, args, actionContext) {
    if (!globalContext_1.getGlobalContext().legacyDispatchWithMiddleware) {
        globalContext_1.getGlobalContext().legacyDispatchWithMiddleware = finalDispatch;
    }
    globalContext_1.getGlobalContext().legacyDispatchWithMiddleware(action, actionType, args, actionContext);
}
exports.dispatchWithMiddleware = dispatchWithMiddleware;
function finalDispatch(action, actionType, args, actionContext) {
    return action();
}
